export default {
      id: "nuit-legerement-voilee-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#nuit-legerement-voilee-usage",
      toString: function () {
        return this.url;
      }
    }